
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"112 102 216 159"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"none","fill-rule":"nonzero","paint-order":"stroke","stroke":"currentColor","stroke-width":"11px","stroke-linecap":"round","stroke-linejoin":"round"},attrs:{"transform":"translate(5 5)","d":"M 302.193 146.8 C 311.971 146.8 319.898 154.728 319.898 164.506 L 319.898 212.216 C 319.898 221.996 311.971 229.923 302.193 229.923 L 297.939 229.923 L 297.256 249.288 L 275.794 229.923 L 208.798 229.923 C 199.019 229.923 191.092 221.996 191.092 212.216 L 191.092 211.869 M 274.575 146.8 L 302.193 146.8"}}),_c('path',{staticStyle:{"fill":"none","fill-rule":"nonzero","paint-order":"stroke","stroke":"currentColor","stroke-width":"11px","stroke-linecap":"round","stroke-linejoin":"round"},attrs:{"d":"M 139.224 108.933 L 240.751 108.933 C 251.381 108.933 259.999 117.551 259.999 128.181 L 259.999 180.046 C 259.999 190.676 251.381 199.294 240.751 199.294 L 167.921 199.294 L 144.59 220.345 L 143.849 199.294 L 139.224 199.294 C 128.594 199.294 119.976 190.676 119.976 180.046 L 119.976 128.181 C 119.976 117.551 128.594 108.933 139.224 108.933 Z"}})])
          )
        }
      }
    